import { ApplicationActions } from '@core/actions/types';
import { Inject, Injectable } from '@angular/core';
import { ApplicationReloader } from '@/app/application-reloader';
import {
  AUTHENTICATED_USER_ACTIONS,
  AuthenticatedUserActions
} from '@/app/platform/platform-core/user/store/types';
import { PlatformUserContext } from '@/app/platform/platform-context/platform-user-context';

@Injectable({
  providedIn: 'root'
})
export class ApplicationActionsFacade implements ApplicationActions {
  constructor(
    private readonly applicationReloader: ApplicationReloader,
    @Inject(AUTHENTICATED_USER_ACTIONS)
    private readonly authenticatedUserActions: AuthenticatedUserActions,
    private readonly userContext: PlatformUserContext
  ) {}

  async resetApplication(): Promise<void> {
    const activeUser = this.userContext.getActiveUser();

    if (activeUser) {
      await this.authenticatedUserActions.desktopLogout();
    }

    localStorage.clear();
    this.applicationReloader.reloadToRoot();
  }
}
